<template>
  <v-container>
    <v-row align="center" class="px-2 mx-3 mt-3">
      <p
        v-for="{ word_en, word_fr, count, i } in words"
        :key="i"
        class="mx-2 px-2 py-1 white--text"
        style="background: #2a69b0"
      >
        {{ lang === "en" ? word_en : word_fr }} ({{ count }})
      </p>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      words: [],
      lang: "",
    };
  },
  computed: {
    visits() {
      const data = this.$store.state.analytics.ConversationMajorTopics;
      return data;
    },
  },
  async created() {
    if (this.visits) await this.init_vals();

    var lang = navigator.language || navigator.userLanguage;
    if (lang == "fr" || lang.split("-")[0] == "fr") {
      // 'fr', 'fr-BE', ...
      this.lang = "fr";
    } else {
      this.lang = "en";
    }
  },
  methods: {
    init_vals() {
      this.words = this.visits.data;
    },
  },
};
</script>
